// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__18GFg","VerificationBox":"Dashboard_VerificationBox__1bRgV"};